import { registerModal } from 'features/Modal/ModalRegistry'
import AddToHomeModal from './AddToHomeModal.container'
import { showModal } from 'features/Modal/Modal.actions'

export const modalType = 'ADD_TO_HOME'
registerModal(modalType, AddToHomeModal)
export default modalProps =>
  showModal({
    modalType,
    modalProps,
  })



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/AddToHome/AddToHomeModal/AddToHomeModal.action.js